var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',[_c('div',[_c('iframe',{staticClass:"w-full h-screen outline-none",attrs:{"title":"Help Center","src":"https://otoride-getting-started.vercel.app/","frameborder":"0"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }